<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/funders/edit">{{lang.LBL_ADD_FUNDER}}</router-link></li>
        <li><router-link to="/modules/funders">{{lang.LBL_VIEW_FUNDER}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/Funders/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
        let user = JSON.parse(localStorage.getItem('user_prefrence'));
        
    },
    methods:{
       
    }
}
</script>
